import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { delimitedTextCompressionTypeOptions } from '../consts/v2Dataset-const';
import { fileTypeLinkedServiceTypes } from '../consts/adf-model-type-map-const';
import { preserveZipFileAsFolderMetadata, preserveCompressionFileAsFolderMetadata } from '../consts/metadata-consts';
import { compressionCodecType, ModelConstants } from 'shell-models-lib';

export const binaryMetadata: IDatasetTypeMetadata = {
    type: ModelConstants.binaryDataset,
    displayName: stringResources.ModelName_BinaryDataset,
    supportLinkedServiceTypes: fileTypeLinkedServiceTypes,
    isSource: true,
    isSink: true,
    datasetKind: 'file',
    notSupportPhysicalType: true,
    notSupportTypeConversion: true,
    icon: {
        className: 'svg-i-20x20-Binary'
    },
    isFirstClass: true,
    category: ['File'],
    isV2FormatDataset: true,
    compressionOptions: delimitedTextCompressionTypeOptions,
    notSupportPreviewData: true,
    supportGetMetadataActivity: true,
    supportDeleteActivity: true,
    notSupportLookupActivity: true,
    notSupportAdditionalColumns: true,
    compressionReadSettingControls: {
        [compressionCodecType.ZipDeflate]: [preserveZipFileAsFolderMetadata],
        [compressionCodecType.TarGZip]: [preserveCompressionFileAsFolderMetadata],
        [compressionCodecType.tar]: [preserveCompressionFileAsFolderMetadata]
    }
};
